/**
 * Константы для компонентов блога
 */

// Дефолтные значения
export const DEFAULT_VALUES = {
    LOCALE: {
        RU: 'ru-RU',
        EN: 'en-US'
    },
    CURRENCY: {
        RU: 'RUB',
        EN: 'USD'
    }
}

// Размеры изображений (оптимизированы для LCP и производительности)
export const IMAGE_SIZES = {
    // Hero изображение для главной статьи (оптимизировано для мобильных)
    HERO: {
        width: 1600,
        height: 900,
        // Размеры для мобильных устройств (для preload)
        mobile: {
            width: 720,
            height: 480
        }
    },
    // Основное изображение статьи (оптимизировано для LCP)
    BLOG_POST_MAIN: {
        width: 1180,  // Еще меньше для снижения веса LCP-изображения
        height: 664,
        // Размеры для мобильных устройств (для preload)
        mobile: {
            width: 640,
            height: 400
        }
    },
    // Изображения внутри статьи
    BLOG_POST: {
        width: 1600,  // Увеличено в 2 раза для Retina
        height: 900   // Увеличено в 2 раза для Retina
    },
    // Карточки статей
    BLOG_CARD: {
        width: 1200,  // Увеличено в 2 раза для Retina
        height: 800   // Увеличено в 2 раза для Retina
    },
    // Карточки на главной странице и в списках
    BLOG_LIST: {
        width: 1200,
        height: 800
    }
}

// Параметры качества изображений (оптимизированы для производительности)
// ВАЖНО: значения должны соответствовать конфигурации в next.config.js (qualities: [75, 85, 95])
export const IMAGE_QUALITY = {
    HIGH: 85,      // Высокое качество для hero/OG-изображений
    MEDIUM: 75,    // Стандартное качество для остальных изображений
    LOW: 75        // Низкое качество для миниатюр
}

// URL социальных сетей для шаринга
export const SOCIAL_SHARE_URLS = {
    TELEGRAM: 'https://t.me/share/url',
    WHATSAPP: 'https://wa.me/',
    FACEBOOK: 'https://www.facebook.com/sharer/sharer.php',
    TWITTER: 'https://twitter.com/intent/tweet'
}

// UI константы
export const UI_CONSTANTS = {
    OPACITY_10_PERCENT: '1A', // Hex для 10% opacity
    NOTIFICATION_TIMEOUT: 2000, // мс
    DEFAULT_IMAGE_ALT: 'Изображение статьи'
}

// Тексты по умолчанию
export const DEFAULT_TEXTS = {
    RU: {
        INTERESTING_ARTICLE: 'Интересная статья',
        LINK_COPIED: 'Ссылка скопирована!',
        COPY_LINK: 'Скопировать ссылку',
        SHARE_TELEGRAM: 'Поделиться в Telegram',
        SHARE_WHATSAPP: 'Поделиться в WhatsApp',
        SHARE_FACEBOOK: 'Поделиться в Facebook',
        SHARE_TWITTER: 'Поделиться в Twitter/X'
    },
    EN: {
        INTERESTING_ARTICLE: 'Interesting article',
        LINK_COPIED: 'Link copied!',
        COPY_LINK: 'Copy link',
        SHARE_TELEGRAM: 'Share on Telegram',
        SHARE_WHATSAPP: 'Share on WhatsApp',
        SHARE_FACEBOOK: 'Share on Facebook',
        SHARE_TWITTER: 'Share on Twitter/X'
    }
}

